import { useQuery } from '@tanstack/react-query';
import i18n from 'i18next';

import { getAPISpec } from '../../helpers';
import {
  getCarrierDocs,
  getInboundDocs,
  getResourcesByType,
} from '../../services';

export const useGetBusinessType = () => {
  return useQuery({
    queryKey: ['business_type'],
    queryFn: () => getResourcesByType({ type: 'business_type' }),
    retry: 1,
  });
};

export const useGetNumberOfSubscribers = () => {
  return useQuery({
    queryKey: ['number_of_subscribers_new_values'],
    queryFn: () =>
      getResourcesByType({ type: 'number_of_subscribers_new_values' }),
    retry: 1,
  });
};

export const useGetCountries = ({ sort }: { sort?: boolean }) => {
  return useQuery({
    queryKey: ['get_contries'],
    queryFn: () => getResourcesByType({ type: 'country' }),
    retry: 1,
    select: data => {
      if (sort) {
        return data.sort((a: any, b: any) =>
          i18n.t(a.id).localeCompare(i18n.t(b.id)),
        );
      }

      return data;
    },
  });
};

export const useGetUserRoles = () => {
  return useQuery({
    queryKey: ['user_role'],
    queryFn: () => getResourcesByType({ type: 'user_role' }),
    retry: 1,
  });
};

export const useGetJobTitles = () => {
  return useQuery({
    queryKey: ['job_title'],
    queryFn: () => getResourcesByType({ type: 'job_title' }),
    retry: 1,
  });
};

export const useGetCarrierDocs = (tags: string[]) => {
  return useQuery({
    queryKey: ['carrier_docs', tags],
    queryFn: () => getCarrierDocs({ paths: tags, silent: true }),
    retry: 1,
    select: response => {
      if (response) {
        return getAPISpec(response);
      }

      return null;
    },
  });
};

export const useGetInboundDocs = (tags: string[]) => {
  return useQuery({
    queryKey: ['inbound_docs', tags],
    queryFn: () => getInboundDocs({ paths: tags, silent: true }),
    retry: 1,
    select: response => {
      if (response) {
        return getAPISpec(response);
      }

      return null;
    },
  });
};
